module.exports = __webpack_public_path__ + "img/media (3).21846e3e.png";